import clientConfig from '@v2/config/client'

let style = {
  cssClassName: '',
  cssBtnColor: '',
  init: function () {
    style.cssClassName = clientConfig.cssClassName[global.PLATFORMID]
    style.cssBtnColor = clientConfig.cssBtnColor[global.PLATFORMID]
    style.cssBgColor = clientConfig.cssBgColor[global.PLATFORMID]
  }
}

export default style



// WEBPACK FOOTER //
// ./src/v2/static/client/style.js